import classNames from "classnames";
import React from "react";

export const TransactionSectionTitle = ({
  title,
  sticky,
  className,
}: {
  title?: string | null;
  sticky?: boolean;
  className?: string;
}) => {
  return (
    <div
      className={classNames("transaction-section-title", { sticky }, className)}
    >
      <h4 className="fw-bold">{title}</h4>

      <style jsx>{`
        .transaction-section-title {
          padding: 0.75rem 0;

          &.sticky {
            position: sticky;
            top: 0;
            background-color: var(--primary-bg-color);
            z-index: 2;
          }

          h4 {
            font-size: var(--font-size-regular);
            margin: 0;
            text-transform: capitalize;
          }
        }
      `}</style>
    </div>
  );
};
